import React, { useEffect, useState } from 'react';
import './FloatingWhatsApp.css';

const FloatingWhatsApp = () => {
  const [isShining, setIsShining] = useState(false);

  useEffect(() => {
    // Trigger shining animation every 3 seconds
    const interval = setInterval(() => {
      setIsShining(true);
      setTimeout(() => setIsShining(false), 1000); // Animation duration
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("¡Hola! Me gustaría contactar con ustedes.");
    window.open(`https://wa.me/525562076934?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="floating-whatsapp">
      <button
        className={`whatsapp-button ${isShining ? 'shining' : ''}`}
        onClick={handleWhatsAppClick}
        aria-label="Contactar por WhatsApp"
      >
        <div className="whatsapp-icon">
          <img src="/icons/whatsapp_icon.svg" alt="WhatsApp" />
        </div>
        <div className="shine-effect"></div>
        <div className="pulse-ring"></div>
      </button>
      
      <div className="tooltip">
        ¡Chatea con nosotros!
      </div>
    </div>
  );
};

export default FloatingWhatsApp;
